    // components/filePreview/renderers/ImageRenderer.tsx
import { Box } from "@mui/material";

export const ImageRenderer = ({ blobUrl }: { blobUrl: string }) => (
  <Box display="flex" justifyContent="center" alignItems="center" height="100%">
    <img
      src={blobUrl}
      alt="preview"
      style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain", borderRadius: 8 }}
    />
  </Box>
);